import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {' Developed and Produced '}
      <Link 
        color="primary" 
        variant="body2" 
        rel="noreferrer" // rel="noopener"
        target="_blank"
        href="https://www.cybermaq.com/">
        by CyberMAQ Informática Electrónica
      </Link>{' 2020 - ' + new Date().getFullYear()} <br />
       {/* Dirección: Depto. La Paz - El Prado Calle Potosí, esquina Loayza frente a la facultad de Derecho - UMSA. */}
    </Typography>
  );
}
// rel = "noopener" evita que la nueva página pueda acceder a la propiedad window.opener y garantiza que se ejecute en un proceso separado. Sin esto, la página de destino puede potencialmente redirigir su página a una URL maliciosa.
// rel = "noreferrer" tiene el mismo efecto, pero también evita que el encabezado Referer se envíe a la nueva página. ⚠️ La eliminación del encabezado de referencia afectará los análisis.

const useStyles = makeStyles((theme) => ({
  footer: {
    backgroundColor: theme.palette.background.paper,
    // marginTop: theme.spacing(8),
    padding: theme.spacing(6, 0),
  },
}));

export default function Footer(props) {
  const classes = useStyles();
  const { description, title } = props;

  return (
    <footer className={classes.footer}>
      <Container maxWidth="lg">
        <Typography variant="h6" align="center" gutterBottom>
          {title}
        </Typography>
        <Typography variant="subtitle1" align="center" color="textSecondary" component="p">
          {description}
        </Typography>
        <Copyright />
      </Container>
    </footer>
  );
}

Footer.propTypes = {
  description: PropTypes.string,
  title: PropTypes.string,
};